import React from 'react';

import type { InterfaceState } from './types';

export default function PortsStatusTable({
  state,
}: {
  state: InterfaceState[];
}) {
  return (
    <div className="w-2/3">
      <h4 className="font-bold">Port Status</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>Port</th>
            <th>Link</th>
            <th>Speed</th>
            <th>Duplex</th>
            <th>MAC</th>
          </tr>
        </thead>
        <tbody>
          {state.map((p) => (
            <tr key={p.interface} className="webui-table-row-content">
              <td className="text-center">{p.interface}</td>
              <td className="text-center">{p.state ? 'up' : 'down'}</td>
              <td className="text-center">{p.state ? p.speed : '-'}</td>
              <td className="text-center">
                {p.state ? `${p.duplex ? 'full' : 'half'}` : '-'}
              </td>
              <td className="truncate text-center">{p.mac}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
